<template>
    <div>
        <pagamentos
            :pagamentos="pagamentosFiltrados"
            :showFornecedor="true"
            v-show="mostrarPagamentos"
            @atualizar-listagem="obterPagamentos()"
        >
            <template slot="controles">
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (DE)</label>
                            </strong>
                            <date-picker
                                ref="dp01"
                                v-model="dataInicial"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data inicial"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Data Atualização (ATÉ)</label>
                            </strong>
                            <date-picker
                                ref="dp02"
                                v-model="dataFinal"
                                :config="$datePickerOptions2"
                                v-mask="'##/##/####'"
                                placeholder="Informe a data final"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Situação</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="situacoesPagamentosSelect"
                                v-model="situacaoPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Status</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="statusPagamentosSelect"
                                v-model="statusPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Filtro por Classificação</label>
                            </strong>
                            <b-form-select
                                :plain="true"
                                :options="classificacaoPagamentosSelect"
                                v-model="classificacaoPagamentos"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </template>
            <template slot="acoes" slot-scope="data">
                <span
                    class="text-primary"
                    v-if="$temAcessoView('GESCON-UFI-PAG-01')"
                >
                    <i
                        class="fa fa-info-circle fa-lg icon-button"
                        title="Detalhar"
                        @click.stop="checarDetalharPagamento(data)"
                    ></i>
                </span>
            </template>
        </pagamentos>
        <router-view></router-view>
    </div>
</template>

<script>
import PagamentosServicos from './PagamentosServicos'
import Pagamentos from '@/app/gescon/pagamentos/Pagamentos'
import StatusPorSituacao from './StatusPorSituacao'
import { pagamentoStatus } from '../../pagamentos/PagamentoStatus'

export default {
    data() {
        return {
            pagamentos: [],
            pagamentosFiltradosSituacao: [],
            pagamentosFiltrados: [],
            statusPagamentos: -1,
            statusPagamentosSelectBase: [
                { text: 'TODOS', value: -1 },
                { text: 'CRIADO', value: 0 },
                { text: 'EM ANÁLISE', value: 1 },
                { text: 'EM PROCESSAMENTO PELO SETOR FINANCEIRO', value: 2 },
                { text: 'REPROVADO', value: 3 },
                { text: 'REPROVADO PELO SETOR FINANCEIRO', value: 4 },
                { text: 'CONCLUÍDO', value: 5 },
                { text: 'AGUARDANDO SETOR FINANCEIRO', value: 9 }
            ],
            statusPagamentosSelect: [],
            situacaoPagamentos: 2,
            situacoesPagamentosSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'NÃO RECEBIDOS', value: 1 },
                { text: 'EM ANÁLISE', value: 2 },
                { text: 'APROVADOS', value: 3 }
            ],
            classificacaoPagamentos: 0,
            classificacaoPagamentosSelect: [
                { text: 'TODOS', value: 0 },
                { text: 'ESPECIAIS', value: 1 },
                { text: 'PRIORITÁRIOS', value: 2 }
            ],
            dataInicial: null,
            dataFinal: null,
            setInicial: true
        }
    },

    methods: {
        obterPagamentos() {
            this.$store.dispatch('addRequest')
            let filtroDto = {
                situacao: this.situacaoPagamentos,
                status: this.statusPagamentos,
                classificacao: this.classificacaoPagamentos,
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : ''
            }
            PagamentosServicos.obterTodos(filtroDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.pagamentos = response.data
                        this.pagamentosFiltrados = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter pagamentos',
                            'ERROR',
                            this.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        checarDetalharPagamento(pagamento) {
            if (this.$temAcesso('GESCON-UFI-PAG-02')
                && pagamento.status == pagamentoStatus.AGUARDANDO_SETOR_FINANCEIRO   
            ) {
                this.processarReprovar(pagamento)
            } else {
                this.detalharPagamento(pagamento.pagamentoId)                
            }
        },

        processarReprovar(pagamento) {
            this.$store.dispatch('addRequest')
            let processareprovaPagamentoDto = {
                pagamentoId: pagamento.pagamentoId,
                acao: 'A',
                detalheReprovacao: null,
            }
            PagamentosServicos
                .aprovarReprovarPagamento(processareprovaPagamentoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.detalharPagamento(pagamento.pagamentoId)                
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        detalharPagamento(id) {
            this.$router.push({
                name: `Gescon_Financeiro_Pagamentos_Detalhar`,
                params: {
                    pagamentoId: id
                }
            })
        },

        processarFiltroStatus(regra) {
            let situacoesPorRegra = StatusPorSituacao.filter((item) => {
                return item.regra == regra
            })

            let situacao = situacoesPorRegra[0].situacoes.filter((item) => {
                return item.id == this.situacaoPagamentos
            })

            this.statusPagamentosSelect =
                this.statusPagamentosSelectBase.filter((item) => {
                    return situacao[0].status.some((p) => p == item.value)
                })

            if (
                !this.statusPagamentosSelect.some(
                    (p) => p.value == this.statusPagamentos
                )
            ) {
                this.statusPagamentos = -1
            } else {
                this.obterPagamentos()
            }
        },

        processarFiltroSituacao() {
            if (this.situacaoPagamentos === 0) {
                this.pagamentosFiltradosSituacao = this.pagamentos.slice()
                this.statusPagamentosSelect =
                    this.statusPagamentosSelectBase.slice()
                this.obterPagamentos()
            } else {
                this.processarFiltroStatus('GESCON-UFI-PAG-00')
            }
        }
    },

    created() {
        let dataAtual = new Date()
        this.dataInicial = this.$moment(dataAtual)
            .startOf('month')
            .format('DD/MM/YYYY')
        this.dataFinal = this.$moment(dataAtual)
            .endOf('month')
            .format('DD/MM/YYYY')
        this.setInicial = false
        this.processarFiltroSituacao()
    },

    computed: {
        mostrarPagamentos() {
            return this.$route.name === 'Gescon_Financeiro_Pagamentos'
        }
    },

    watch: {
        $route(to) {
            if (to.name === 'Gescon_Financeiro_Pagamentos') {
                this.obterPagamentos()
            }
        },

        statusPagamentos() {
            this.obterPagamentos()
        },

        situacaoPagamentos() {
            this.processarFiltroSituacao()
        },

        classificacaoPagamentos() {
            this.processarFiltroSituacao()
        },

        dataInicial() {
            if (this.dataInicial) {
                this.$refs.dp02.dp.minDate(this.dataInicial)
            } else {
                this.$refs.dp02.dp.minDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        },

        dataFinal() {
            if (this.dataFinal) {
                this.$refs.dp01.dp.maxDate(this.dataFinal)
            } else {
                this.$refs.dp01.dp.maxDate(false)
            }
            if (!this.setInicial) {
                this.processarFiltroSituacao()
            }
        }
    },

    components: {
        Pagamentos
    }
}
</script>
